import { ModelBase } from "@shoothill/core";
import { makeObservable, observable } from "mobx";
import { nanoid } from "nanoid";
import { Validator } from "Application/Validation";
import { container } from "tsyringe";
import { LookupStore } from "Stores/Domain/LookupStore";

export class StudentAbsenceModel extends ModelBase<StudentAbsenceModel> {
    public KEY: string = nanoid();
    public id: string | null = null;
    public studentSessionId: string = "";
    public absenseTypeId: string | null = null;
    public reason: string = "";
    public didAttend: boolean = false;

    constructor() {
        super();
        makeObservable(this, {
            studentSessionId: observable,
            absenseTypeId: observable,
            reason: observable,
            didAttend: observable,
        });
    }
}

export class StudentAbsenceModelModelValidator extends Validator<StudentAbsenceModel> {
    constructor() {
        super();
        this.ruleFor("absenseTypeId")
            .notNull()
            .withMessage("Please select a reason why")
            .when((model) => {
                return !model.didAttend;
            });
        this.ruleFor("reason")
            .notEmpty()
            .withMessage("Please enter a Reason")
            .when((model) => {
                if (model.didAttend) return false;
                const lookupStore = container.resolve(LookupStore);
                const absenceType = lookupStore.absenceTypes.find((t) => t.id === model.absenseTypeId);
                return absenceType?.name === "Other";
            });
    }
}
